import ErrorPage from './ErrorPage';
import notFoundIcon from './not-found-icon.svg';

const NotFound = () => (
  <ErrorPage
    icon={notFoundIcon}
    header="404: Crickets"
    subHeader="The page you’re trying to reach does not exist."
    linkText="Go to Stream"
    linkHref="/"
  />
);

export default NotFound;
